import { Box, BoxProps } from '@chakra-ui/react';
import { rem } from 'polished';

export const ProminentButtonBackground = ({ position, ...boxProps }: BoxProps) => (
  <Box
    borderRadius={rem(5)}
    position={position && position !== 'static' ? position : 'relative'}
    backgroundColor="black"
    backgroundImage="linear-gradient(103.61deg, #131313 25.73%, #4B4B4B 108.9%)"
    _after={{
      content: '""',
      display: 'block',
      position: 'absolute',
      inset: 0,
      backgroundColor: 'inherit',
      opacity: 0,
      transition: 'opacity 333ms',
    }}
    sx={{
      'button:hover > &::after, a:hover > &::after': {
        opacity: 0.15,
      },
    }}
    {...boxProps}
  />
);
